import { Component, Input, OnInit } from '@angular/core';
import { runtimeEnvironment } from '../../environments/environment';

@Component({
    selector: 'app-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss', './web-app.skeleton.component.scss', './chrome-extension.skeleton.component.scss'],
    standalone: false
})
export class SkeletonComponent implements OnInit {
  renderMode = runtimeEnvironment.renderMode;

  @Input()
  style = '';

  // TODO: Add a count of how many parts/'bones'(?) to repeat
  @Input()
  count = 1;
  Array = Array;

  constructor() {}

  ngOnInit(): void {}
}
